import AuthStorage from './auth';
import BaseStorageService from './base';
import ChatStorage from './chat';
import DataManageStorage from './dataManage';
import EaseMobStorage from './easemob';
import GlobalStorage from './global';
import OnceStorage from './once';

export enum LOCAL_STORAGE_KEYS {
  SwitchModelConfirm = 'SwitchModelConfirm',
  InpaintGuide = 'InpaintGuide',
}

class AppStorage extends BaseStorageService {
  chat: ChatStorage;
  auth: AuthStorage;
  dataManage: DataManageStorage;
  global: GlobalStorage;
  easeMob: EaseMobStorage;
  once: OnceStorage;

  constructor() {
    super();
    this.chat = new ChatStorage();
    this.auth = new AuthStorage();
    this.dataManage = new DataManageStorage();
    this.global = new GlobalStorage();
    this.easeMob = new EaseMobStorage();
    this.once = new OnceStorage();
  }
}

// 全局 storage 单例
export const storage = new AppStorage();
